import { render } from "./SliderBar.vue?vue&type=template&id=15c7d048"
import script from "./SliderBar.vue?vue&type=script&lang=js"
export * from "./SliderBar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__